import { PITCH_GEOMETRY } from './PitchGeometry';
import type { PlayerRuntimeState } from './PlayerRuntimeState';
import { clamp, distance } from './Vector2';

/**
 * Creates the temporary, lawful layout used only for a kick-off. It does not
 * reuse the playing formation: every non-taker starts in their own half and
 * the tactical systems subsequently decide how to occupy the field.
 */
export function arrangeKickoff(players: PlayerRuntimeState[], kickingSide: 0 | 1): PlayerRuntimeState {
  const outfield = players
    .filter((player) => player.teamSide === kickingSide && player.positionType !== 'GK')
    .sort((first, second) => distance(first.homePosition, PITCH_GEOMETRY.centre) - distance(second.homePosition, PITCH_GEOMETRY.centre)
      || first.playerId.localeCompare(second.playerId));
  const taker = outfield[0];
  if (!taker) throw new Error('A kick-off requires an outfield player');
  const support = outfield[1];

  for (const player of players) {
    const position = kickoffPosition(player);
    player.position = position;
    player.velocity = { x: 0, y: 0 };
    player.targetPosition = { ...player.homePosition };
    player.tacticalTarget = { ...player.homePosition };
    player.contextualTarget = { ...player.homePosition };
    player.recoveryTarget = { ...player.homePosition };
    player.hasBall = false;
  }

  taker.position = { ...PITCH_GEOMETRY.centre };
  taker.targetPosition = { ...PITCH_GEOMETRY.centre };
  taker.contextualTarget = { ...PITCH_GEOMETRY.centre };
  if (support) {
    support.position = {
      x: PITCH_GEOMETRY.worldX(kickingSide, 47),
      y: clamp(support.homePosition.y, 42, 58),
    };
  }
  return taker;
}

function kickoffPosition(player: PlayerRuntimeState) {
  const progress = player.positionType === 'GK' ? 7
    : player.positionType === 'DF' ? 27
      : player.positionType === 'MF' ? 39 : 46;
  return {
    x: PITCH_GEOMETRY.worldX(player.teamSide, progress),
    y: clamp(player.homePosition.y, 7, 93),
  };
}
